/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserIdDto } from './userIdDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface FileDto {
  base64Content?: string;
  creator?: UserIdDto;
  expiration?: string;
  fileName?: string;
  fileType?: string;
  id?: number;
  label?: string;
  owner?: EnterpriseIdDto;
  state?: string;
  updated?: string;
  url?: string;
}
